/**
 * Client-side gate for the admin claim-status override. This is a speed bump
 * only. The backend admin-role check is the real control. The secret ships in
 * the JavaScript bundle. The value matches the other admin password gates
 * (TEMP_PASSWORD_FOR_COHORTS and BULK_UNBILLABLE_PASSWORD). It stays a separate
 * constant so this flow can change its password on its own later.
 */
export const CHANGE_CLAIM_STATUS_PASSWORD = 'opnjhaJZBLo4';
